import { Record } from 'immutable';

export const SocketStates = Object.freeze({
  CONNECTING: 'CONNECTING',
  OPEN: 'OPEN',
  ERROR: 'ERROR',
  CLOSING: 'CLOSING',
  CLOSED: 'CLOSED',
  AUTHENTICATED: 'AUTHENTICATED',
  RECONNECTING: 'RECONNECTING',
});
// eslint-disable-line no-undef

export const mkBumpStore = Record({
  socketState: 'CLOSED',
});

export const BUMP_REDUCER_KEY = 'bump';

export const CLOSE_BUMP_DISABLED = 4000;
export const CLOSE_BUMP_NEEDS_RECONNECTION = 4001;
